export const adminDashboardBreadcrumbs = {
  dashboard: {
    label: "Admin Dashboard",
    link: "/admin",
  },
  users: {
    label: "Users",
    link: "/admin/users",
  },
  userLogs: {
    label: "User Logs",
    link: "/admin/users",
  },
  userSubscription: {
    label: "User Subscription",
    link: "/admin/users",
  },
  subscriptionPlans: {
    label: "Subscription Plans",
    link: "/admin/subscription-plans",
  },
  subscriptionOffers: {
    label: "Subscription Offers",
    link: "/admin/subscription-offers",
  },
  eventSubscriptions: {
    label: "Event Subscriptions",
    link: "/admin/event-subscriptions",
  },
};
